/**
 * 后台菜单「图标」字段的可选清单。
 *
 * 数据来源（两者取并集，均为实际加载了字体、能正常显示的类名）：
 *   1. public/cdn/element-ui/2.4.0/theme-chalk/index.css      —— 运行时 element-ui 自带
 *   2. public/cdn/element-icons/2.15.14/icon-latest.css       —— 2.15.14 图标增量包
 *
 * 项目通过 externals 走 CDN 引入 element-ui，npm 包不参与打包，
 * 所以这里不能直接用 node_modules 里的图标清单（会包含大量无法显示的图标）。
 *
 * 重新生成方式：提取上述两个 CSS 中所有 `.el-icon-xxx:before` 的类名，取并集后按字母序排列。
 * 升级 element-ui CDN 版本、或新增/更换图标包后，必须重新生成本文件，
 * 否则选择器里会出现选了却显示不出来的图标。
 */

/** 常用图标，图标选择器默认展示，减少查找成本 */
export const MENU_ICONS_COMMON = [
  'el-icon-s-home',
  'el-icon-menu',
  'el-icon-s-grid',
  'el-icon-setting',
  'el-icon-s-tools',
  'el-icon-user',
  'el-icon-s-custom',
  'el-icon-user-solid',
  'el-icon-goods',
  'el-icon-s-goods',
  'el-icon-document',
  'el-icon-s-order',
  'el-icon-tickets',
  'el-icon-folder',
  'el-icon-folder-opened',
  'el-icon-files',
  'el-icon-s-shop',
  'el-icon-location',
  'el-icon-location-information',
  'el-icon-search',
  'el-icon-edit',
  'el-icon-edit-outline',
  'el-icon-delete',
  'el-icon-plus',
  'el-icon-circle-plus',
  'el-icon-circle-plus-outline',
  'el-icon-check',
  'el-icon-circle-check',
  'el-icon-close',
  'el-icon-view',
  'el-icon-star-on',
  'el-icon-star-off',
  'el-icon-bell',
  'el-icon-message',
  'el-icon-date',
  'el-icon-time',
  'el-icon-alarm-clock',
  'el-icon-s-data',
  'el-icon-s-marketing',
  'el-icon-s-finance',
  'el-icon-s-management',
  'el-icon-s-cooperation',
  'el-icon-s-platform',
  'el-icon-s-promotion',
  'el-icon-s-release',
  'el-icon-s-claim',
  'el-icon-s-check',
  'el-icon-s-flag',
  'el-icon-s-ticket',
  'el-icon-s-opportunity',
  'el-icon-money',
  'el-icon-coin',
  'el-icon-wallet',
  'el-icon-bank-card',
  'el-icon-price-tag',
  'el-icon-discount',
  'el-icon-present',
  'el-icon-box',
  'el-icon-truck',
  'el-icon-service',
  'el-icon-phone',
  'el-icon-key',
  'el-icon-lock',
  'el-icon-unlock',
  'el-icon-picture',
  'el-icon-video-camera',
  'el-icon-upload2',
  'el-icon-download',
  'el-icon-printer',
  'el-icon-notebook-2',
  'el-icon-collection-tag',
  'el-icon-office-building'
];

/** 全部可用图标（共 282 个） */
export const MENU_ICONS = [
  'el-icon-add-location',
  'el-icon-aim',
  'el-icon-alarm-clock',
  'el-icon-apple',
  'el-icon-arrow-down',
  'el-icon-arrow-left',
  'el-icon-arrow-right',
  'el-icon-arrow-up',
  'el-icon-attract',
  'el-icon-back',
  'el-icon-bangzhu',
  'el-icon-bank-card',
  'el-icon-baseball',
  'el-icon-basketball',
  'el-icon-bell',
  'el-icon-bicycle',
  'el-icon-bottom',
  'el-icon-bottom-left',
  'el-icon-bottom-right',
  'el-icon-box',
  'el-icon-brush',
  'el-icon-burger',
  'el-icon-c-scale-to-original',
  'el-icon-camera',
  'el-icon-camera-solid',
  'el-icon-caret-bottom',
  'el-icon-caret-left',
  'el-icon-caret-right',
  'el-icon-caret-top',
  'el-icon-chat-dot-round',
  'el-icon-chat-dot-square',
  'el-icon-chat-line-round',
  'el-icon-chat-line-square',
  'el-icon-chat-round',
  'el-icon-chat-square',
  'el-icon-check',
  'el-icon-cherry',
  'el-icon-chicken',
  'el-icon-circle-check',
  'el-icon-circle-check-outline',
  'el-icon-circle-close',
  'el-icon-circle-close-outline',
  'el-icon-circle-plus',
  'el-icon-circle-plus-outline',
  'el-icon-close',
  'el-icon-close-notification',
  'el-icon-cloudy',
  'el-icon-cloudy-and-sunny',
  'el-icon-coffee',
  'el-icon-coffee-cup',
  'el-icon-coin',
  'el-icon-cold-drink',
  'el-icon-collection',
  'el-icon-collection-tag',
  'el-icon-connection',
  'el-icon-coordinate',
  'el-icon-copy-document',
  'el-icon-cpu',
  'el-icon-crop',
  'el-icon-d-arrow-left',
  'el-icon-d-arrow-right',
  'el-icon-d-caret',
  'el-icon-data-analysis',
  'el-icon-data-board',
  'el-icon-data-line',
  'el-icon-date',
  'el-icon-delete',
  'el-icon-delete-location',
  'el-icon-delete-solid',
  'el-icon-dessert',
  'el-icon-discount',
  'el-icon-discover',
  'el-icon-dish',
  'el-icon-dish-1',
  'el-icon-document',
  'el-icon-document-add',
  'el-icon-document-checked',
  'el-icon-document-copy',
  'el-icon-document-delete',
  'el-icon-document-remove',
  'el-icon-download',
  'el-icon-edit',
  'el-icon-edit-outline',
  'el-icon-eleme',
  'el-icon-error',
  'el-icon-female',
  'el-icon-files',
  'el-icon-film',
  'el-icon-finished',
  'el-icon-first-aid-kit',
  'el-icon-folder',
  'el-icon-folder-add',
  'el-icon-folder-checked',
  'el-icon-folder-delete',
  'el-icon-folder-opened',
  'el-icon-folder-remove',
  'el-icon-food',
  'el-icon-football',
  'el-icon-fork-spoon',
  'el-icon-full-screen',
  'el-icon-goblet',
  'el-icon-goblet-full',
  'el-icon-goblet-square',
  'el-icon-goblet-square-full',
  'el-icon-goods',
  'el-icon-grape',
  'el-icon-guide',
  'el-icon-headset',
  'el-icon-heavy-rain',
  'el-icon-help',
  'el-icon-hot-water',
  'el-icon-house',
  'el-icon-ice-cream',
  'el-icon-ice-cream-round',
  'el-icon-ice-cream-square',
  'el-icon-ice-drink',
  'el-icon-ice-tea',
  'el-icon-info',
  'el-icon-key',
  'el-icon-knife-fork',
  'el-icon-light-rain',
  'el-icon-lightning',
  'el-icon-link',
  'el-icon-loading',
  'el-icon-location',
  'el-icon-location-information',
  'el-icon-location-outline',
  'el-icon-lock',
  'el-icon-lollipop',
  'el-icon-magic-stick',
  'el-icon-male',
  'el-icon-map-location',
  'el-icon-medal',
  'el-icon-medal-1',
  'el-icon-menu',
  'el-icon-message',
  'el-icon-message-solid',
  'el-icon-mic',
  'el-icon-microphone',
  'el-icon-milk-tea',
  'el-icon-minus',
  'el-icon-mobile',
  'el-icon-mobile-phone',
  'el-icon-money',
  'el-icon-monitor',
  'el-icon-moon',
  'el-icon-moon-night',
  'el-icon-more',
  'el-icon-more-outline',
  'el-icon-mouse',
  'el-icon-news',
  'el-icon-no-smoking',
  'el-icon-notebook-1',
  'el-icon-notebook-2',
  'el-icon-odometer',
  'el-icon-office-building',
  'el-icon-open',
  'el-icon-orange',
  'el-icon-paperclip',
  'el-icon-partly-cloudy',
  'el-icon-pear',
  'el-icon-phone',
  'el-icon-phone-outline',
  'el-icon-picture',
  'el-icon-picture-outline',
  'el-icon-picture-outline-round',
  'el-icon-pie-chart',
  'el-icon-place',
  'el-icon-platform-eleme',
  'el-icon-plus',
  'el-icon-position',
  'el-icon-postcard',
  'el-icon-potato-strips',
  'el-icon-present',
  'el-icon-price-tag',
  'el-icon-printer',
  'el-icon-question',
  'el-icon-rank',
  'el-icon-reading',
  'el-icon-receiving',
  'el-icon-refresh',
  'el-icon-refresh-left',
  'el-icon-refresh-right',
  'el-icon-refrigerator',
  'el-icon-remove',
  'el-icon-remove-outline',
  'el-icon-right',
  'el-icon-s-check',
  'el-icon-s-claim',
  'el-icon-s-comment',
  'el-icon-s-cooperation',
  'el-icon-s-custom',
  'el-icon-s-data',
  'el-icon-s-finance',
  'el-icon-s-flag',
  'el-icon-s-fold',
  'el-icon-s-goods',
  'el-icon-s-grid',
  'el-icon-s-help',
  'el-icon-s-home',
  'el-icon-s-management',
  'el-icon-s-marketing',
  'el-icon-s-open',
  'el-icon-s-operation',
  'el-icon-s-opportunity',
  'el-icon-s-order',
  'el-icon-s-platform',
  'el-icon-s-promotion',
  'el-icon-s-release',
  'el-icon-s-shop',
  'el-icon-s-ticket',
  'el-icon-s-tools',
  'el-icon-s-unfold',
  'el-icon-school',
  'el-icon-scissors',
  'el-icon-search',
  'el-icon-sell',
  'el-icon-service',
  'el-icon-set-up',
  'el-icon-setting',
  'el-icon-share',
  'el-icon-ship',
  'el-icon-shopping-bag-1',
  'el-icon-shopping-bag-2',
  'el-icon-shopping-cart-1',
  'el-icon-shopping-cart-2',
  'el-icon-shopping-cart-full',
  'el-icon-smoking',
  'el-icon-soccer',
  'el-icon-sold-out',
  'el-icon-sort',
  'el-icon-sort-down',
  'el-icon-sort-up',
  'el-icon-star-off',
  'el-icon-star-on',
  'el-icon-stopwatch',
  'el-icon-success',
  'el-icon-sugar',
  'el-icon-suitcase',
  'el-icon-suitcase-1',
  'el-icon-sunny',
  'el-icon-sunrise',
  'el-icon-sunrise-1',
  'el-icon-sunset',
  'el-icon-switch-button',
  'el-icon-table-lamp',
  'el-icon-tableware',
  'el-icon-takeaway-box',
  'el-icon-thumb',
  'el-icon-tickets',
  'el-icon-time',
  'el-icon-timer',
  'el-icon-toilet-paper',
  'el-icon-top',
  'el-icon-top-left',
  'el-icon-top-right',
  'el-icon-trophy',
  'el-icon-trophy-1',
  'el-icon-truck',
  'el-icon-turn-off',
  'el-icon-turn-off-microphone',
  'el-icon-umbrella',
  'el-icon-unlock',
  'el-icon-upload',
  'el-icon-upload2',
  'el-icon-user',
  'el-icon-user-solid',
  'el-icon-video-camera',
  'el-icon-video-camera-solid',
  'el-icon-video-pause',
  'el-icon-video-play',
  'el-icon-view',
  'el-icon-wallet',
  'el-icon-warning',
  'el-icon-warning-outline',
  'el-icon-watch',
  'el-icon-watch-1',
  'el-icon-water-cup',
  'el-icon-watermelon',
  'el-icon-wind-power',
  'el-icon-zoom-in',
  'el-icon-zoom-out'
];
